import {HEARTYSAN_USER_TYPES, SYSTEM_ROLES} from "@/staticData/staticVariables";

export const munuFunc = {
  methods: {

    /**
     * Група вважається видимою, якщо є хоч один пункт з доступним пермішеном,
     * який юзер додатково не сховав у налаштуваннях меню (is_hide)
     */
    checkVisibleGroupMenu(links, groupKey) {
      let flag = false
      links.map(item => {
        if(this._.has(item, 'permissionLinkName')){
          if(this._.has(this.currentPermissions, item.permissionLinkName)){
            if(!this.isMenuLinkHidden(groupKey, item.translation)){
              flag = true
            }
          }
        }
      })
      return flag
    },

    /**
     * Той самий перелік перевірок, що й для видимості пункту в самому меню
     * (permissionLinkName, hiddenOptionArr) — перевикористовується і в MenuItem,
     * і в попапі налаштувань меню, щоб юзер не міг показати пункт, недоступний по пермішену
     */
    checkVisibleMenuItem(item) {
      let ids = [20002, 22474, 20000, 21137]
      if(item.translation === 'menu_orderScales' && !ids.includes(this.getCurrentUserProfile?.id)) {
        return false
      }

      if(this.isUserHasEasyOrder) {
        if(!item?.hiddenOptionArr || item.hiddenOptionArr.indexOf('isEasyOrder') === -1) {
          return false
        }
      }

      if(this._.has(item, 'permissionLinkName')){
        if(!this._.has(this.currentPermissions, item.permissionLinkName)){
          return false
        }
      }
      if(this._.has(item, 'hiddenOptionArr') && item.hiddenOptionArr.indexOf('paymentListings') > -1){
        if(!this.getCurrentUserSetting?.use_payment_listing && !this.getCurrentUserSetting?.use_paypal_button){
          return false
        }
      }
      if(this._.has(item, 'hiddenOptionArr') && item.hiddenOptionArr.indexOf('isBelarus') > -1){
        if(!this.isBelarus){
          return false
        }
      }
      if(this._.has(item, 'hiddenOptionArr') && item.hiddenOptionArr.indexOf('isUkrainian') > -1){
        if(!this.isUkrainian){
          return false
        }
      }
      if(this._.has(item, 'hiddenOptionArr') && item.hiddenOptionArr.indexOf('isPoland') > -1){
        if(!this.isPoland){
          return false
        }
      }
      if(this._.has(item, 'hiddenOptionArr') && item.hiddenOptionArr.indexOf('userManage') > -1){
        if(this.getUserRole?.id === SYSTEM_ROLES.SYSTEM_ROLE_SUB_USER.id)
          return false
      }

      // Heartysan
      if(this._.has(item, 'hiddenOptionArr') && item.hiddenOptionArr.indexOf('heartysanChoice') > -1){
        if(this.getCurrentUser?.hearty_user_type)
          return false
      }
      if(this._.has(item, 'hiddenOptionArr') && item.hiddenOptionArr.indexOf('heartysanManufacturer') > -1){
        if(this.getCurrentUser?.hearty_user_type?.id !== HEARTYSAN_USER_TYPES.HEARTYSAN_MANUFACTURER.id)
          return false
      }
      if(this._.has(item, 'hiddenOptionArr') && item.hiddenOptionArr.indexOf('heartysanSeller') > -1){
        if(this.getCurrentUser?.hearty_user_type?.id !== HEARTYSAN_USER_TYPES.HEARTYSAN_SELLER.id)
          return false
      }

      return true
    },

    /**
     * Видимість дочірнього (nested) пункту меню — лише перевірка пермішена
     */
    checkVisibleMenuSubItem(itemChild) {
      if(this._.has(itemChild, 'permissionLinkName')){
        if(!this._.has(this.currentPermissions, itemChild.permissionLinkName)){
          return false
        }
      }
      return true
    },

    /**
     * Знайти збережені юзером налаштування пункту меню (is_hide/own_translation)
     * parentTranslation — для пошуку в вкладеному child-масиві
     */
    getMenuLinkSettings(groupKey, translation, parentTranslation = null) {
      let group = this.$store.getters.getMenuSettings?.[groupKey]
      if(!group?.links) return null

      if(parentTranslation) {
        let parent = this._.find(group.links, {translation: parentTranslation})
        if(!parent?.child) return null
        return this._.find(parent.child, {translation}) || null
      }

      return this._.find(group.links, {translation}) || null
    },

    isMenuLinkHidden(groupKey, translation, parentTranslation = null) {
      if(!groupKey) return false
      return !!this.getMenuLinkSettings(groupKey, translation, parentTranslation)?.is_hide
    },

    getMenuLinkOwnTranslation(groupKey, translation, parentTranslation = null) {
      if(!groupKey) return ''
      return this.getMenuLinkSettings(groupKey, translation, parentTranslation)?.own_translation || ''
    },

    initMenu() {
      // console.log(this.subIsActive('/dashboard'));
      /***  Custom accordion (slideToggle analog) for menu  ***/

      let accordionItemTitles = document.querySelectorAll(".accordItemTitlesJs");

      let alternativeAccordionItemTitles = []

      if (window.innerWidth < 1550 && window.innerWidth > 680) {

        let onlyMainTitle = document.querySelectorAll(".side-bar__menu-item");


        for (let i = 0; i < onlyMainTitle.length; i++) {
          onlyMainTitle[i].addEventListener("click",function () {
            console.log(onlyMainTitle[i].closest('section'))
            onlyMainTitle[i].closest('.side-bar__menu').scrollIntoView()
          });
        }



        for (let i = 0; i < accordionItemTitles.length - 1; i++) {
          if(!accordionItemTitles[i].classList.contains('side-bar__menu-item-name')) {
            alternativeAccordionItemTitles.push(accordionItemTitles[i])
          }
        }
        accordionItemTitles = alternativeAccordionItemTitles.slice()
      }

      for (let i = 0; i < accordionItemTitles.length; i++) {
        accordionItemTitles[i].addEventListener("click",
          function (event) {
            event.preventDefault();
            let menuItem = event.target
            if(!menuItem.classList.contains('accordItemTitlesJs')) {
              menuItem = menuItem.closest('.accordItemTitlesJs')
            }
            menuItem.classList.toggle("open");
            let accordionItemContent = menuItem.nextElementSibling;

            if (!accordionItemContent.classList.contains('open')) {
              accordionItemContent.classList.add('open');
              accordionItemContent.style.height = 'auto';

              let height = accordionItemContent.clientHeight + 'px';

              accordionItemContent.style.height = '0px';

              setTimeout(function () {
                accordionItemContent.style.height = height;
              }, 0);
              setTimeout(function () {
                accordionItemContent.style.height = 'auto';
              }, 300);
            } else {

              let heightClose = accordionItemContent.clientHeight + 'px';
              accordionItemContent.style.height = heightClose;

              setTimeout(function () {
                accordionItemContent.style.height = '0px';
                accordionItemContent.addEventListener('transitionend',
                  function () {
                    accordionItemContent.classList.remove('open');
                  }, {
                    once: true
                  });
              }, 100);

            }
          });
      }
      setTimeout(function () {

        for (let i = 0; i < accordionItemTitles.length; i++) {
          if (accordionItemTitles[i].classList.contains('open')) {
            let nextItem = accordionItemTitles[i].nextElementSibling;
            nextItem.classList.add('open');
            nextItem.style.height = 'auto';
          }
        }
      }, 1);
      /***  END  ***/


      /***  When the screen is less than 1550 pixels, opening and closing the menu  ***/


      let sideBar = document.getElementById('side-bar');
      let sideBarMenuItems = document.querySelectorAll(".side-bar__menu-item");
      let sideBarMenuItemsIco = document.querySelectorAll(".side-bar__menu-item-ico");

      if (window.innerWidth < 1550) {

        for (let i = 0; i < sideBarMenuItemsIco.length; i++) {
          sideBarMenuItemsIco[i].addEventListener("click",
            function (event) {

              if (
                sideBarMenuItemsIco[i].parentElement.classList.contains('active')
                && sideBar.classList.contains('open')
              ) {
                sideBar.classList.remove('open');
              } else {
                sideBar.classList.add('open');
              }

              for (let y = 0; y < sideBarMenuItems.length; y++) {
                sideBarMenuItems[y].classList.remove('active');

                sideBarMenuItems[y].children[1].children[0].classList.remove('open'); /*fix 1400 pixel open item resize*/

                if (sideBarMenuItems[y].children[1].children[1])
                  sideBarMenuItems[y].children[1].children[1].classList.remove('open'); /*fix 1400 pixel open item resize*/
              }

              event.preventDefault();
              sideBarMenuItemsIco[i].parentElement.classList.add('active');

              let sideBarMenuItemContent = sideBarMenuItemsIco[i].nextElementSibling;
              sideBarMenuItemContent.children[0].classList.add('open');
              if (sideBarMenuItemContent.children[1])
                sideBarMenuItemContent.children[1].classList.add('open');
            }
          );
        }

      }

      document.addEventListener('click', (e) => {
        if (document.querySelector('.side-bar.open') !== null) {
          if (e.target.closest('.side-bar') === null) {
            sideBar.classList.remove('open');
          }
        }
      })
      /***  END  ***/

    }

  }
}
